export const collectionMockDescription = {
  ABC: "Our bestselling pant collection. Engineered for whatever the day brings.",
  "Metal Vent Tech":
    "Our ultimate sweat collection. Breathable and chafe-free.",
  Commission:
    "A modern take on workwear. Wrinkle-resistant and ultra-comfortable.",
};
